import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesAddToPortalComponent } from './properties-add-to-portal.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [PropertiesAddToPortalComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatToolbarModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  exports: [PropertiesAddToPortalComponent]
})
export class PropertiesAddToPortalModule { }
